import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { GetApp } from '@mui/icons-material';
import { filesize } from 'filesize';

interface AttachmentLinkProps {
  attachment: {
    size: number;
    title: string;
    url: string;
  };
  size?: 'small' | 'medium' | 'large';
}

function AttachmentLink({ attachment, size = 'medium' }: AttachmentLinkProps) {
  return (
    <Box sx={{ display: 'flex' }}>
      <Button
        component="a"
        size={size}
        rel="noopener noreferrer"
        href={attachment.url}
        startIcon={<GetApp aria-hidden="true" />}
        variant="outlined"
        role="link"
        aria-label={attachment.title}
        title={attachment.title}
        sx={{ textTransform: 'none', display: 'flex' }}
      >
        <Typography
          variant="body2"
          component="span"
          sx={{
            textOverflow: 'ellipsis',
            overflowX: 'hidden',
            fontWeight: 'bold',
          }}
        >
          {attachment.title}
        </Typography>
        <Typography
          variant="body2"
          component="span"
          aria-hidden="true"
          sx={{
            ml: 1,
            whiteSpace: 'nowrap',
            '&:before': {
              content: '"—"',
              mr: 1,
            },
          }}
        >
          {filesize(attachment.size)}
        </Typography>
      </Button>
    </Box>
  );
}

export default AttachmentLink;
